export enum ELocalstorageKeys {
	AuthDepartmentId = 'auth_department_id',
	AuthTenantId = 'auth_tenant_id',
}
